var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{class:_vm.mobile ? 'router-link router-link-mobile' : 'router-link router-link-desktop',attrs:{"to":_vm.to}},[_c('svg-vue',{staticClass:"mx-3 w-5 h-5 transition ease-in-out duration-150",attrs:{"icon":_vm.icon}}),_vm._v("\n  "+_vm._s(_vm.label)+"\n")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }